import { MasterDetailListEntry } from "@sdbn/common";

export class DataProtectionRule implements MasterDetailListEntry {
    id: number;
    name: string;

    constructor(rule: any) {
        if (rule != null) {
            this.id = rule.id;
            this.name = rule.name;
        }
    }

    public get listTitle(): string {
        return this.name;
    }

    public get listTitleDictionaryKey(): string {
        return null;
    }

    public get listSubTitle(): string {
        return null;
    }

    public get groupIdentifier(): String {
      return null;
    }

    public get childs() : Array<MasterDetailListEntry> {
      return null;
    }
}

export class DataProtectionRuleDetails {

    id: number;
    name: string;
    defaultRule = false;
    disabled = false;

    phoneEnabled = false;
    phone: string;

    numberPlateEnabled = false;
    numberPlate: string;

    trailerNumberPlateEnabled = false;
    trailerNumberPlate: string;

    swapTrailerNumberEnabled = false;
    swapTrailerNumber: string;

    driverEnabled = false;
    driver: string;

    coDriverEnabled = false;
    coDriver: string;

    carrierEnabled = false;
    carrier: string;

    supplierEnabled = false;
    supplier: string;

    identityCardEnabled = false;
    identityCard: string;

    mailEnabled = false;
    mail: string;

    resourcesEnabled = false;
    resources: string;

    constructor(rule?: any) {
        if (rule != null) {
            this.id = rule.id;
            this.name = rule.name;
            this.defaultRule = rule.defaultRule;
            this.disabled = rule.disabled;
            this.phoneEnabled = rule.phoneEnabled;
            this.phone = rule.phone;
            this.numberPlateEnabled = rule.numberPlateEnabled;
            this.numberPlate = rule.numberPlate;
            this.trailerNumberPlateEnabled = rule.trailerNumberPlateEnabled;
            this.trailerNumberPlate = rule.trailerNumberPlate;
            this.swapTrailerNumberEnabled = rule.swapTrailerNumberEnabled;
            this.swapTrailerNumber = rule.swapTrailerNumber;
            this.driverEnabled = rule.driverEnabled;
            this.driver = rule.driver;
            this.coDriverEnabled = rule.coDriverEnabled;
            this.coDriver = rule.coDriver;
            this.carrierEnabled = rule.carrierEnabled;
            this.carrier = rule.carrier;
            this.supplierEnabled = rule.supplierEnabled;
            this.supplier = rule.supplier;
            this.identityCardEnabled = rule.identityCardEnabled;
            this.identityCard = rule.identityCard;
            this.mailEnabled = rule.mailEnabled;
            this.mail = rule.mail;
            this.resourcesEnabled = rule.resourcesEnabled;
            this.resources = rule.resources;
        }
    }
}
